<template>
    <div class="remodal remodal-modal-chart" data-remodal-id="modal-chart" data-remodal-options="hashTracking: false" style="max-width: none;">
        <div class="responsive-message">{{ __('A mérettáblázat képe oldalra mozgatható!') }}</div>
        <div class="size-chart-wrap">
            <img :src="product.sizeTable" alt="" />
        </div>
        <button data-remodal-action="close" class="remodal-close"></button>
    </div>
</template>

<script>
export default {
    name: 'SizeTable',

    props: {
        product: {
            type: Object,
        }
    }
}
</script>

<style scoped>

</style>
